import { ScaleLoader } from '@saeris/vue-spinners'

export default {
  name:'ScaleLoader',
  //props:["loading", "size","color","width","height","margin","radius","customclass"],
  props:{
    loading: {
      //type: Boolean,
      default: false,
    },
    color: {
      default: "#007ACC",
    },
    height: {
      default: 30,
    },
    width: {
      default: 4,
    },
    radius: {
      default: 2,
    },
    margin: {
      default: "2px",
    },
    customclass: {
      default: "custom-class",
    },
  },
  data: () => ({
    //loading: true
  }),
  render() {
    return (
      <div>
        <ScaleLoader
          class={this.customclass}
          loading={this.loading}
          color={this.color}
          //size={150}
          height={this.height}
          width={this.width}
          radius={this.radius}
          margin={this.margin}
          sizeUnit={"px"}
        />
      </div>
    )
  }
}